import { Skeleton as AntSkeleton, Button, Flex, Row, Typography } from "antd";
import styled, { css } from "styled-components";

import { BRAND_BOOK_COLORS } from "~/Constant/Theme/configs/equipmentshare";
import { TRADE_GOTHIC_NEXT_FONT_FAMILY } from "~/Constant/Theme/constants";
import { TokenProps } from "~/types";

const TRANSPARENT_ORANGE = "rgba(241, 102, 34, 0.05)";

export const LocationCardContainer = styled("div")<
  TokenProps & {
    $popup?: boolean;
    $onClick: boolean;
    $active?: boolean;
    $hoverStyles?: boolean;
  }
>`
  background: ${(props) =>
    props.$active ? TRANSPARENT_ORANGE : props.$token.colorWhite};
  border: 1px solid
    ${(props) =>
      props.$active ? props.$token.colorPrimary : props.$token.colorWhite};
  ${(props) => (props.$onClick ? "cursor: pointer;" : undefined)}
  ${(props) =>
    props.$popup
      ? css`
          border: none !important;
          margin: 0 !important;
          ${props.$breakpoints?.sm
            ? css`
                max-width: 25rem;
                min-width: 20rem;
              `
            : undefined}
          padding: 0;
        `
      : css`
          box-shadow: ${BRAND_BOOK_COLORS.BOX_SHADOW_LARGE} !important;
          padding: 1rem;
        `};

  ${(props) =>
    props.$hoverStyles
      ? css`
          &:hover {
            background: ${TRANSPARENT_ORANGE};
            border: 1px solid
              ${props.$active ? props.$token.colorPrimary : TRANSPARENT_ORANGE};
          }
        `
      : undefined}
  border-radius: 0.25rem;
  font-family: ${TRADE_GOTHIC_NEXT_FONT_FAMILY};
  margin: 0.5rem;
  max-width: 100%;
  transition: background, border 200ms ease-in;
`;

export const Skeleton = styled(AntSkeleton.Button).attrs({
  active: true,
})``;

export const LocationNameStyled = styled(Typography.Title).attrs<
  TokenProps & { $popup?: boolean }
>({
  level: 3,
})`
  color: ${(props) => props.$token.colorText} !important;
  display: block;
  font-size: ${(props) =>
    props.$popup && !props.$breakpoints?.sm
      ? "0.875rem"
      : "1.125rem"} !important;
  font-weight: 800 !important;
  margin: 0 !important;
  text-transform: uppercase !important;

  & a {
    color: ${(props) => props.$token.colorText} !important;
  }
`;

export const LocationAddressStyled = styled(Typography.Text)<
  TokenProps & { $popup?: boolean }
>`
  display: block;
  font-size: ${(props) =>
    props.$popup && !props.$breakpoints?.sm ? "0.75rem" : "0.875rem"};
  font-weight: 400 !important;
`;

export const LocationHoursStatusStyled = styled(Typography.Text)`
  display: block;
  font-size: 0.875rem;
  font-weight: 700 !important;
`;

export const LocationHoursTextStyled = styled(Typography.Text)`
  display: block;
  font-size: 0.875rem;
  font-weight: 400 !important;
`;

export const RowLocationCta = styled(Row)`
  margin-bottom: 1rem;
  margin-top: 0.5rem;
`;

export const LocationCtaStyled = styled(Typography.Link)<
  TokenProps & { $popup?: boolean }
>`
  display: block;
  font-weight: 400 !important;
  height: 100%;
  vertical-align: middle;

  &:hover span {
    color: ${(props) => props.$token.colorPrimary} !important;
  }
`;

export const LocationButtonContainer = styled(Flex).attrs({
  gap: "small",
  vertical: true,
})`
  width: 100%;
`;

export const LocationButtonStyled = styled(Button).attrs({
  block: true,
})<TokenProps & { $popup?: boolean }>`
  border-radius: 0.25rem;
  font-weight: 700 !important;

  ${(props) =>
    props.ghost
      ? css`
          background-color: ${props.$token.colorWhite} !important;
          color: ${props.$token.colorText} !important;
          &:hover {
            background-color: ${props.$token.colorPrimary} !important;
            color: ${props.$token.colorWhite} !important;
          }
        `
      : undefined}

  span {
    color: inherit !important;
    ${(props) =>
      props.$popup && !props.$breakpoints?.sm
        ? "font-size: 0.75rem !important;"
        : undefined}
  }
`;

export const InlineChildren = styled.div`
  & > * {
    display: inline;
    &:not(:first-child) {
      margin-left: 0.5rem;
    }
  }
`;

export const NoWrapText = styled(Typography.Text)<
  TokenProps & { $popup?: boolean }
>`
  white-space: nowrap;

  ${(props) =>
    !props.$breakpoints?.sm && props.$popup
      ? css`
          font-size: 0.8125rem;
        `
      : undefined}
`;
